import { createBooleanStorageItem } from '@page/core/lib/web/storage';

import { useStorageAsState } from '../../web/useStorageAsState';

export const isCreateOrgStorage = createBooleanStorageItem('is-create-org', { storage: sessionStorage });

export const useIsCreateOrgStorage = () => {
  return useStorageAsState(isCreateOrgStorage);
};
